<div class="blur-content">
    <div class="page-container" style="background-color: #f2f8fa !important">
      <app-sidebar-menu [selected]="selected" [isAdmin]="true"></app-sidebar-menu>
      <div class="main-content">
        <app-header></app-header>
        <div class="main-content-inner">
          <div class="row mt-5">
            <div
              class="col-12"
              style="padding-right: 0 !important; margin-right: 0 !important"
            >
              <div class="card">
                <div class="card-body">
                  <!-- Only show content when departments are loaded -->
                  <div>
                    <div class="text-center mb-4">
                      <h2>Department & Task Management</h2>
                      <p>Select a department from the dropdown and manage your tasks. Click the + button to add new tasks.</p>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="card mb-4">
                          <div class="card-header"><h3>Departments</h3></div>
                          <div class="card-body">
                             <div *ngIf="isLoadingDepartments" class="d-flex justify-content-center align-items-center" style="height: 150px;">
                              <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>
                            <div *ngIf="!isLoadingDepartments">
                                <div class="form-group">
                              <label for="department-select">Select Department</label>
                              <ng-select id="department-select"
                                         [items]="departments"
                                         [(ngModel)]="selectedDepartment"
                                         (change)="onDepartmentChange()"
                                         [clearable]="true"
                                         [searchable]="false">
                                <ng-template ng-arrow-wrapper>
                                  <div class="ng-arrow">
                                    <i class="fa fa-chevron-down"></i>
                                  </div>
                                </ng-template>
                              </ng-select>
                            </div>
                            <div *ngIf="selectedDepartment" class="selected-department-display mt-3">
                              Selected: {{ getSelectedDepartmentName() }}
                            </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="card">
                          <div class="card-header d-flex justify-content-between align-items-center">
                            <h3>Tasks</h3>
                            <button [disabled]="!selectedDepartment" [title]="!selectedDepartment ? 'No department selected!' : 'Create Task'" class="btn btn-sm add-task-btn" (click)="toggleAddTaskInput()">+</button>
                          </div>
                          <div class="card-body">
                            <div *ngIf="isLoadingTasks" class="d-flex justify-content-center align-items-center" style="height: 150px;">
                              <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>

                            <div *ngIf="!isLoadingTasks" class="task-list">
                              <div class="task-item" *ngFor="let task of tasks">
                                <span class="task-name">{{task.taskName}}</span>
                                <button class="delete-task-btn" (click)="deleteTask(task)">x</button>
                              </div>
                              <div class="no-tasks" *ngIf="tasks.length === 0">
                                No tasks for this department.
                              </div>
                            </div>

                            <div class="add-task-form mt-3" *ngIf="showAddTaskInput">
                              <div class="d-flex align-items-center">
                                <input type="text" class="form-control mr-2" placeholder="Enter new task name" [(ngModel)]="newTaskName">
                                <button class="btn btn-sm btn-secondary mr-2" (click)="cancelAddTask()">Cancel</button>
                                <button class="btn btn-sm btn-success" (click)="addTask()">Add</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
